import { render, staticRenderFns } from "./shipprovider.vue?vue&type=template&id=25cfc40a"
import script from "./shipprovider.vue?vue&type=script&lang=js"
export * from "./shipprovider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports